import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { CalendarCheck, MessageCircle } from "lucide-react";

const BOOK_URL = "https://portal.pivot1st.co.uk/book/2/class";

export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  const [atFooter, setAtFooter] = useState(false);

  useEffect(() => {
    const footer = document.querySelector('[data-testid="footer"]');
    if (!footer) return;
    const obs = new IntersectionObserver(([entry]) => setAtFooter(entry.isIntersecting));
    obs.observe(footer);
    return () => obs.disconnect();
  }, [pathname]);

  if (pathname.startsWith("/admin")) return null;

  return (
    <div
      className={`lg:hidden fixed inset-x-0 bottom-0 z-40 transition-transform duration-300 ${
        atFooter ? "translate-y-full" : "translate-y-0"
      }`}
      data-testid="sticky-mobile-cta"
    >
      <div className="flex gap-3 bg-white/95 backdrop-blur-xl border-t border-slate-200 px-4 py-3 shadow-[0_-8px_24px_-8px_rgba(10,37,64,0.25)]">
        <a
          href={BOOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 bg-[#FF7A1A] text-white font-bold py-3 rounded-full"
          data-testid="sticky-book-cta"
        >
          <CalendarCheck size={18} /> Book now
        </a>
        <Link
          to="/contact"
          className="flex-1 inline-flex items-center justify-center gap-2 bg-[#0A2540] text-white font-bold py-3 rounded-full"
          data-testid="sticky-enquire-cta"
        >
          <MessageCircle size={18} /> Enquire
        </Link>
      </div>
    </div>
  );
}
